import { Pipe, PipeTransform } from '@angular/core';
import { AuthService } from '../services/auth.service';
import moment from 'moment';
import 'moment/min/locales';
import 'moment-timezone';
import { ProfileSettings } from '../interfaces';

@Pipe({
  name: 'mtmTimePipe',
  standalone: false,
})
export class MtmTimePipe implements PipeTransform {
  private readonly timeFormat: string;
  authUserSettings: ProfileSettings | null;

  constructor(private readonly authService: AuthService) {
    this.timeFormat = '12hs';
    this.authUserSettings = this.authService.getAuthUserSettings();
  }

  transform(value: any): string {
    if (this.authUserSettings?.timeFormat != this.timeFormat) {
      const today: Date = new Date(value);
      const formattedTime = moment(today).format('HH:mm');
      return formattedTime;
    } else {
      const today: Date = new Date(value);
      const formattedTime = moment(today).format('hh:mm a');
      return formattedTime;
    }
  }
}
